import React, { useState } from 'react';

import { useCookieContext, CloseButton } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import Tracking from '@spotahome/soyuz-tracking';

import './ValueProposition.scss';

const COOKIE_NAME = 'sah-search-value-proposition';
const COOKIE_VALUE = 1;
const COOKIE_15_DAYS = 60 * 60 * 24 * 15;

const BULLET_POINTS = [
  {
    renderIcon: () => <i className="ds-icon-device_portrait" />,
    key: 'search.value_proposition.rentals'
  },
  {
    renderIcon: () => <i className="ds-icon-check_circle" />,
    key: 'search.value_proposition.fraud-protection'
  },
  {
    renderIcon: () => <i className="ds-icon-diamond" />,
    key: 'search.value_proposition.cancellation'
  }
];

const ValueProposition = () => {
  const { getCookie, setCookie } = useCookieContext();
  const [isClosed, setIsClosed] = useState(!!getCookie(COOKIE_NAME));

  const handleClose = eventLabel => {
    Tracking.ga.sendEvent('Search', 'ValueProposition', eventLabel);
    setCookie(COOKIE_NAME, COOKIE_VALUE, { maxAge: COOKIE_15_DAYS });
    setIsClosed(true);
  };

  if (isClosed || getCookie(COOKIE_NAME)) {
    return null;
  }

  return (
    <div className="value-proposition">
      <div className="value-proposition__wrapper">
        {BULLET_POINTS.map(bulletPoint => (
          <div
            className="value-proposition__bullet-point"
            key={bulletPoint.key}
          >
            {bulletPoint.renderIcon()}
            <span>{trans(bulletPoint.key)}</span>
          </div>
        ))}
      </div>
      <CloseButton
        size="small"
        className="value-proposition__close"
        onClick={handleClose}
      />
    </div>
  );
};

export default ValueProposition;
